module.exports = __webpack_public_path__ + "media/Video 103.56eec414.mp4";